/* Size chart pop-up. Added 2026-10-06. Markup comes from snippets/rr-size-guide.liquid.

   ONE DIALOG ON <body>. Each "Size chart" button has a matching <template>
   next to it. On click the template is copied into a single <dialog> that
   lives on <body>. It is deliberately not rendered inside the product block:
   Horizon re-renders (morphs) the product details on every variant change,
   which would close or wipe a pop-up living in there.

   CLICK HANDLING IS DELEGATED from document, so buttons that arrive later
   (morphs, quick add) work with no re-binding, and loading this file twice
   is harmless (guarded by window.__rrSizeGuide).

   WHAT THE CUSTOMER SEES. The chart opens on the size and colour they already
   picked: the row for the checked Size is highlighted, and on hoodies with
   tie-dyes the Tie-dye table is shown when a Tie Dye colour is checked. Read
   from the variant picker's radio inputs (data-option-name="Size"/"Color").

   Closing: the X, the "Back to sizes" button, Escape (native <dialog>), or a
   tap on the dimmed backdrop. Focus returns to the button that opened it. */
(function () {
  'use strict';
  if (window.__rrSizeGuide) return;
  window.__rrSizeGuide = true;

  var dialog = null;
  var opener = null;

  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'rr-sg__dialog';
    dialog.setAttribute('aria-label', 'Size chart');
    dialog.addEventListener('click', function (event) {
      // Backdrop click: the event target is the dialog itself, outside the panel.
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('rr-sg-open');
      if (opener && document.contains(opener)) {
        try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
      }
    });
    document.body.appendChild(dialog);
    return dialog;
  }

  function checkedValue(scope, optionName) {
    var input = scope.querySelector("input[data-option-name='" + optionName + "']:checked");
    if (!input) input = document.querySelector("input[data-option-name='" + optionName + "']:checked");
    return input ? input.value : '';
  }

  function showTable(panel, which) {
    var tables = panel.querySelectorAll('[data-rr-sg-table]');
    var found = false;
    Array.prototype.forEach.call(tables, function (table) {
      if (table.getAttribute('data-rr-sg-table') === which) found = true;
    });
    if (!found) which = 'solid';
    Array.prototype.forEach.call(tables, function (table) {
      table.hidden = table.getAttribute('data-rr-sg-table') !== which;
    });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-rr-sg-tab]'), function (tab) {
      tab.setAttribute('aria-pressed', tab.getAttribute('data-rr-sg-tab') === which ? 'true' : 'false');
    });
  }

  function open(button) {
    var uid = button.getAttribute('data-rr-sg-open');
    var holder = button.closest('.rr-sg') || document;
    var template = holder.querySelector('template[data-rr-sg-template="' + uid + '"]');
    if (!template) return;

    var d = getDialog();
    d.innerHTML = '';
    var panel = document.createElement('div');
    panel.className = 'rr-sg__panel';
    panel.appendChild(template.content.cloneNode(true));
    d.appendChild(panel);

    // Start on what the customer already picked.
    var scope = button.closest('product-form-component, .rr-buybox, .product-details, section') || document;
    var color = checkedValue(scope, 'Color').toLowerCase();
    showTable(panel, color.indexOf('tie dye') !== -1 || color.indexOf('tie-dye') !== -1 ? 'tiedye' : 'solid');

    var size = checkedValue(scope, 'Size');
    if (size) {
      Array.prototype.forEach.call(panel.querySelectorAll('tr[data-rr-sg-size]'), function (row) {
        if (row.getAttribute('data-rr-sg-size') === size) {
          row.classList.add('is-picked');
          row.setAttribute('aria-current', 'true');
        }
      });
    }

    opener = button;
    document.documentElement.classList.add('rr-sg-open');
    if (typeof d.showModal === 'function') {
      d.showModal();
    } else {
      d.setAttribute('open', '');
    }
    var x = d.querySelector('.rr-sg__x');
    if (x) x.focus();
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.documentElement.classList.remove('rr-sg-open');
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var openBtn = target.closest('[data-rr-sg-open]');
    if (openBtn) {
      event.preventDefault();
      open(openBtn);
      return;
    }

    if (dialog && dialog.contains(target)) {
      if (target.closest('[data-rr-sg-close]')) {
        event.preventDefault();
        close();
        return;
      }
      var tab = target.closest('[data-rr-sg-tab]');
      if (tab) {
        showTable(dialog, tab.getAttribute('data-rr-sg-tab'));
      }
    }
  });
})();
